import React, { Component } from 'react'
import './index.css'
import IconClose from "../IconClose";
import { closeOptions, timeframeOptions } from '../../constants';

class LucketCloseOptionsIcon extends Component {

    state = {
        edit: false
    }
    edit = () => {
        if (this.props.closeOptionsMenuOpen === false) {
            this.props.setCloseOptionsMenuOpenProp(true);
        } else {
            this.props.setCloseOptionsMenuOpenProp(false);
        }
    }

    set = (event, v) => {
        event.stopPropagation();
        this.setState({ edit: false })
        this.props.setCloseOption(v);
    }

    render() {

        return (
            <div className="LucketCloseOptionIcon"
                onClick={this.edit}>
                {this.props.closeOption}

                {(this.props.closeOptionsMenuOpen === true) ?
                    <div>
                        <div className="TimeFrameCallout" />
                        <div id="menu" className="TimeFrameMenu">
                            {closeOptions.filter(
                                o => o !== this.props.closeOption
                            ).map(o =>
                                <div className="LucketTimeFrameIconShort"
                                    onClick={(e) => this.set(e, o)}>{o}</div>
                            )}
                            <IconClose edit={this.edit} key={"close"} />
                        </div></div> : null}
            </div>)
    }

}

export default LucketCloseOptionsIcon